import { render, staticRenderFns } from "./Offershelp.vue?vue&type=template&id=042820d8&"
import script from "./Offershelp.vue?vue&type=script&lang=js&"
export * from "./Offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042820d8')) {
      api.createRecord('042820d8', component.options)
    } else {
      api.reload('042820d8', component.options)
    }
    module.hot.accept("./Offershelp.vue?vue&type=template&id=042820d8&", function () {
      api.rerender('042820d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FaxLTpuSJ7Ab/JS/comp/Offershelp.vue"
export default component.exports